module.exports = __webpack_public_path__ + "assets/images/hypertension_r.80d73670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hypertension_r.png
// module id = 741
// module chunks = 1